// import { Link } from "react-router-dom";
// import {
//   FileText,
//   AudioLines,
//   BookOpen,
//   Mic,
//   CheckCircle,
//   Globe,
//   Layers,
//   ShieldCheck,
//   ArrowRight,
// } from "lucide-react";

// const PhoneticTranscription = () => {
//   const services = [
//     {
//       icon: FileText,
//       title: "IPA Transcription",
//       desc: "Accurate International Phonetic Alphabet transcription by trained linguists.",
//     },
//     {
//       icon: AudioLines,
//       title: "Phoneme-Level Annotation",
//       desc: "Detailed phoneme segmentation for speech recognition systems.",
//     },
//     {
//       icon: BookOpen,
//       title: "Prosody & Intonation",
//       desc: "Stress, rhythm, pitch and suprasegmental feature annotation.",
//     },
//     {
//       icon: Mic,
//       title: "Dialect & Accent Coverage",
//       desc: "Regional and accent-based transcription for inclusive AI models.",
//     },
//   ];

//   const benefits = [
//     "Improves ASR accuracy across accents and languages",
//     "Enables natural and expressive TTS systems",
//     "Supports academic and linguistic research",
//     "Enhances pronunciation training platforms",
//     "Ensures consistent phonetic representation",
//     "Critical for multilingual voice AI systems",
//   ];

//   const useCases = [
//     {
//       title: "Speech Recognition Systems",
//       desc: "Training datasets for automatic speech recognition engines.",
//     },
//     {
//       title: "Text-to-Speech (TTS)",
//       desc: "High-quality phonetic data for natural voice synthesis.",
//     },
//     {
//       title: "Linguistics & Research",
//       desc: "Phonetic studies, corpus linguistics and speech analysis.",
//     },
//     {
//       title: "Language Learning Platforms",
//       desc: "Pronunciation training and learner feedback systems.",
//     },
//   ];

//   const languages = [
//     "English",
//     "Spanish",
//     "French",
//     "German",
//     "Mandarin",
//     "Arabic",
//     "Hindi",
//     "Japanese",
//     "Portuguese",
//     "Russian",
//     "+40 more languages",
//   ];

//   const industries = [
//     "AI & Software Companies",
//     "Universities & Research Labs",
//     "Language Learning Platforms",
//     "Speech Therapy Clinics",
//     "Media & Dubbing Studios",
//     "Voice-Enabled Smart Devices",
//   ];

//   const process = [
//     {
//       title: "Audio Collection & Review",
//       desc: "Secure ingestion and quality evaluation of speech recordings.",
//     },
//     {
//       title: "Phonetic Transcription",
//       desc: "IPA-based transcription by trained linguists.",
//     },
//     {
//       title: "Phoneme & Prosody Annotation",
//       desc: "Segmentation and suprasegmental tagging.",
//     },
//     {
//       title: "Quality Assurance",
//       desc: "Multi-stage validation with consensus review.",
//     },
//     {
//       title: "Delivery & Support",
//       desc: "Export in standard formats with ongoing revisions.",
//     },
//   ];

//   return (
//     <div className="min-h-screen bg-white font-inter">
//       {/* HERO */}
//       <section className="relative h-[500px] overflow-hidden bg-slate-900">
//         {/* Background Image */}
//         <div
//           className="absolute inset-0 bg-cover bg-center"
//           style={{
//             backgroundImage:
//               "url('https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=1920&q=80')",
//           }}
//         />

//         {/* Dark overlay */}
//         <div className="absolute inset-0 bg-black/75" />

//         <div className="relative max-w-7xl mx-auto px-6 h-full flex items-center">
//           <div className="text-white max-w-3xl">
//             <h1 className="text-4xl sm:text-5xl font-light mb-4 tracking-tight">
//               Phonetic Transcription & Tagging
//             </h1>

//             <p className="text-lg text-slate-300 max-w-2xl mb-6 font-light">
//               Expert phonetic transcription services for speech AI, linguistics,
//               and voice technology applications.
//             </p>

//             <Link
//               to="/contact"
//               className="inline-flex items-center gap-2 bg-white text-slate-900 px-7 py-3 rounded-md font-medium hover:bg-slate-100 transition-colors"
//             >
//               Request Services
//               <ArrowRight className="w-4 h-4" />
//             </Link>
//           </div>
//         </div>
//       </section>

//       {/* WHY IT MATTERS */}
//       <section className="py-24 px-6 bg-slate-50">
//         <div className="max-w-6xl mx-auto text-center">
//           <h2 className="text-4xl font-light mb-6">
//             Why Phonetic Transcription Matters
//           </h2>
//           <p className="text-lg text-slate-600 max-w-3xl mx-auto mb-16 font-light">
//             Accurate phonetic representation allows machines and humans to
//             understand speech beyond spelling—capturing pronunciation,
//             variation, and meaning with precision.
//           </p>

//           <div className="grid md:grid-cols-3 gap-6">
//             {benefits.map((b, i) => (
//               <div key={i} className="p-6 bg-white border border-slate-200">
//                 <CheckCircle className="w-6 h-6 mb-3 text-slate-700" />
//                 <p className="font-light text-slate-800">{b}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* SERVICES */}
//       <section className="py-24 px-6">
//         <div className="max-w-7xl mx-auto">
//           <h2 className="text-4xl font-light text-center mb-16">
//             Our Services
//           </h2>

//           <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
//             {services.map((s) => (
//               <div
//                 key={s.title}
//                 className="p-8 bg-slate-900 text-white hover:bg-slate-800 transition"
//               >
//                 <s.icon className="w-8 h-8 mb-4" />
//                 <h3 className="text-xl font-medium mb-2">{s.title}</h3>
//                 <p className="text-slate-300 font-light text-sm">{s.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* LANGUAGE COVERAGE */}
//       <section className="py-24 px-6 bg-slate-50">
//         <div className="max-w-7xl mx-auto text-center">
//           <h2 className="text-4xl font-light mb-6">Global Language Coverage</h2>
//           <p className="text-slate-600 max-w-3xl mx-auto mb-12 font-light">
//             Our linguist network supports accurate transcription across major
//             world languages and regional dialects.
//           </p>

//           <div className="flex flex-wrap justify-center gap-4">
//             {languages.map((lang) => (
//               <span
//                 key={lang}
//                 className="px-6 py-3 bg-white border border-slate-200"
//               >
//                 {lang}
//               </span>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* USE CASES */}
//       <section className="py-24 px-6">
//         <div className="max-w-7xl mx-auto">
//           <h2 className="text-4xl font-light text-center mb-16">Use Cases</h2>

//           <div className="grid md:grid-cols-2 gap-6">
//             {useCases.map((u) => (
//               <div
//                 key={u.title}
//                 className="p-8 bg-slate-50 border border-slate-200"
//               >
//                 <Layers className="w-6 h-6 text-slate-700 mb-4" />
//                 <h3 className="text-xl font-medium mb-2">{u.title}</h3>
//                 <p className="text-slate-600 font-light">{u.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* QUALITY & COMPLIANCE */}
//       <section className="py-24 px-6 bg-slate-50">
//         <div className="max-w-6xl mx-auto text-center">
//           <h2 className="text-4xl font-light mb-6">Quality & Compliance</h2>
//           <p className="text-slate-600 max-w-3xl mx-auto mb-16 font-light">
//             Our workflows ensure linguistic accuracy, consistency, and secure
//             handling of sensitive audio data.
//           </p>

//           <div className="grid md:grid-cols-3 gap-6">
//             {[
//               "Multi-level linguistic QA",
//               "Native & expert linguist review",
//               "Secure data handling practices",
//             ].map((q) => (
//               <div key={q} className="p-6 bg-white border border-slate-200">
//                 <ShieldCheck className="w-6 h-6 mb-3 text-slate-700" />
//                 <p className="font-light">{q}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* INDUSTRIES */}
//       <section className="py-24 px-6">
//         <div className="max-w-7xl mx-auto">
//           <h2 className="text-4xl font-light text-center mb-16">
//             Industries We Serve
//           </h2>

//           <div className="grid md:grid-cols-3 gap-6">
//             {industries.map((ind) => (
//               <div
//                 key={ind}
//                 className="p-8 bg-white border border-slate-200 text-center"
//               >
//                 <Globe className="w-6 h-6 mx-auto mb-3 text-slate-700" />
//                 <p className="font-light">{ind}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* PROCESS */}
//       <section className="py-24 px-6 bg-slate-900 text-white">
//         <div className="max-w-6xl mx-auto">
//           <h2 className="text-4xl font-light text-center mb-16">
//             Our Workflow
//           </h2>

//           <div className="space-y-6">
//             {process.map((p, i) => (
//               <div
//                 key={p.title}
//                 className="flex gap-6 p-8 bg-slate-800 border border-slate-700"
//               >
//                 <div className="w-12 h-12 bg-white text-slate-900 flex items-center justify-center">
//                   {i + 1}
//                 </div>
//                 <div>
//                   <h3 className="text-xl font-medium mb-1">{p.title}</h3>
//                   <p className="text-slate-300 font-light">{p.desc}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section className="py-24 bg-white border-t border-slate-200">
//         <div className="max-w-4xl mx-auto text-center px-6">
//           <h2 className="text-3xl sm:text-4xl font-light mb-8">
//             Need Expert Phonetic Transcription?
//           </h2>
//           <p className="text-slate-600 font-light mb-8">
//             Partner with experienced linguists to build accurate and scalable
//             speech datasets.
//           </p>
//           <Link
//             to="/contact"
//             className="inline-flex items-center gap-2 bg-slate-900 text-white px-8 py-3 font-medium"
//           >
//             Get Started <ArrowRight className="w-4 h-4" />
//           </Link>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default PhoneticTranscription;

import { Link } from "react-router-dom";
import {
  FileText,
  AudioLines,
  BookOpen,
  Mic,
  CheckCircle2,
  Globe2,
  Layers,
  ShieldCheck,
  ArrowRight,
  Languages,
  Activity,
  SearchCheck,
  Lock, // <--- Add this line
} from "lucide-react";
import { motion } from "framer-motion";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
};

const PhoneticTranscription = () => {
  const services = [
    {
      icon: FileText,
      title: "IPA Transcription",
      desc: "High-precision International Phonetic Alphabet (IPA) mapping by certified linguists.",
    },
    {
      icon: AudioLines,
      title: "Phoneme Annotation",
      desc: "Granular phoneme-level segmentation engineered for robust speech recognition training.",
    },
    {
      icon: BookOpen,
      title: "Prosodic Tagging",
      desc: "Suprasegmental feature annotation including stress, rhythm, and intonation pitch.",
    },
    {
      icon: Mic,
      title: "Dialect Architectures",
      desc: "Regional accent and dialectal variation mapping for inclusive voice AI models.",
    },
  ];

  const languages = [
    "English",
    "Spanish",
    "French",
    "German",
    "Mandarin",
    "Arabic",
    "Hindi",
    "Japanese",
    "Portuguese",
    "Russian",
  ];

  return (
    <main className="min-h-screen bg-white font-inter selection:bg-indigo-100">
      {/* ================= HERO SECTION ================= */}
      <section className="relative h-[450px] flex items-center overflow-hidden bg-[#0f172a]">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20 scale-105"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=1920&q=80')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#0f172a]/90 to-transparent" />

        <div
          className="absolute inset-0 opacity-[0.05] pointer-events-none"
          style={{
            backgroundImage: `radial-gradient(#4f46e5 0.5px, transparent 0.5px)`,
            backgroundSize: "30px 30px",
          }}
        />

        <div className="relative max-w-7xl mx-auto px-6 w-full">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-2xl"
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-bold tracking-[0.3em] uppercase mb-6">
              Acoustic Engineering
            </div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight leading-tight">
              Enterprise <span className="text-indigo-400">Phonetic</span>{" "}
              Intelligence.
            </h1>
            <p className="text-base text-slate-300 text-white mb-8 leading-relaxed font-light">
              Expert phonetic transcription and granular linguistic tagging
              engineered for advanced Speech AI, inclusive voice technology, and
              NLP architectures.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-indigo-600 text-white px-6 py-2.5 rounded-lg text-sm font-bold hover:bg-indigo-700 transition-all shadow-lg shadow-indigo-900/40"
            >
              Consult a Linguist <ArrowRight size={16} />
            </Link>
          </motion.div>
        </div>
      </section>

      {/* ================= CORE SERVICES ================= */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-left mb-16">
            <span className="text-indigo-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-3">
              Capabilities
            </span>
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              Precision Linguistic Services
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {services.map((s, idx) => (
              <motion.div
                key={idx}
                {...fadeUp}
                className="group p-8 rounded-2xl border border-slate-100 bg-white hover:border-indigo-100 hover:shadow-xl transition-all"
              >
                <div className="w-12 h-12 bg-slate-50 flex items-center justify-center rounded-xl text-slate-900 group-hover:bg-indigo-600 group-hover:text-white transition-all mb-6 shadow-sm">
                  <s.icon size={24} />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-3 tracking-tight group-hover:text-indigo-600 transition-colors">
                  {s.title}
                </h3>
                <p className="text-[13px] text-slate-500 leading-relaxed font-light">
                  {s.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= TECHNICAL MATRIX (WHY IT MATTERS) ================= */}
      <section className="py-24 bg-slate-50 border-y border-slate-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-12 gap-12 items-center">
            <motion.div {...fadeUp} className="lg:col-span-5">
              <h2 className="text-3xl font-bold text-slate-900 mb-6 tracking-tight">
                The Impact of Phonetic Precision
              </h2>
              <p className="text-slate-600 mb-8 leading-relaxed font-light text-lg">
                Phonetic representation captures speech beyond mere orthography.
                We bridge the gap between spelling and actual pronunciation to
                power expressive AI.
              </p>
              <div className="space-y-4">
                {[
                  "Improves ASR across regional accents",
                  "Enables natural, human-like TTS synthesis",
                  "Facilitates multilingual voice expansion",
                  "Hardens pronunciation training logic",
                ].map((item) => (
                  <div
                    key={item}
                    className="flex items-center gap-3 text-sm font-semibold text-slate-700"
                  >
                    <CheckCircle2
                      size={18}
                      className="text-indigo-600 shrink-0"
                    />{" "}
                    {item}
                  </div>
                ))}
              </div>
            </motion.div>

            <motion.div
              {...fadeUp}
              transition={{ delay: 0.2 }}
              className="lg:col-span-7 grid sm:grid-cols-2 gap-4"
            >
              {[
                {
                  t: "Speech Recognition",
                  d: "Ground-truth datasets for acoustic model tuning.",
                },
                {
                  t: "Voice Synthesis",
                  d: "Phonetic data for neural text-to-speech engines.",
                },
                {
                  t: "Linguistic Research",
                  d: "Corpus-level analysis for academic speech studies.",
                },
                {
                  t: "Language Learning",
                  d: "Real-time feedback loops for pronunciation apps.",
                },
              ].map((use, i) => (
                <div
                  key={i}
                  className="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm hover:border-indigo-200 transition-all"
                >
                  <Layers className="text-indigo-600 mb-4" size={24} />
                  <h4 className="font-bold text-slate-900 text-sm mb-2">
                    {use.t}
                  </h4>
                  <p className="text-xs text-slate-500 leading-relaxed font-light">
                    {use.d}
                  </p>
                </div>
              ))}
            </motion.div>
          </div>
        </div>
      </section>

      {/* ================= GLOBAL COVERAGE & INDUSTRIES ================= */}
      <section className="py-24 bg-white relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-6">
          <div className="bg-[#0f172a] rounded-[2.5rem] p-10 md:p-16 text-white relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-indigo-500/10 blur-[100px] rounded-full" />

            <div className="relative z-10 grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <Languages className="text-indigo-400 mb-6" size={40} />
                <h3 className="text-3xl font-bold mb-4 tracking-tight text-white">
                  Supported Languages
                </h3>
                <p className="text-slate-400 text-lg font-light leading-relaxed mb-8">
                  Our network supports 50+ major world languages and regional
                  dialects with native-speaker verification.
                </p>
                <div className="flex flex-wrap gap-2">
                  {languages.map((lang) => (
                    <span
                      key={lang}
                      className="px-4 py-1.5 bg-white/5 border border-white/10 rounded-lg text-xs font-medium text-slate-300"
                    >
                      {lang}
                    </span>
                  ))}
                  <span className="px-4 py-1.5 bg-indigo-600/20 border border-indigo-600/30 rounded-lg text-xs font-bold text-indigo-400 tracking-wider">
                    +40 MORE
                  </span>
                </div>
              </div>

              <div className="space-y-6">
                <h4 className="text-[10px] font-black text-indigo-400 uppercase tracking-[0.3em] mb-4">
                  Industries Served
                </h4>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    "Speech Therapy Clinics",
                    "Media & Dubbing Studios",
                    "Smart Device Vendors",
                    "University Research Labs",
                  ].map((ind) => (
                    <div
                      key={ind}
                      className="flex items-center gap-3 bg-white/5 p-4 rounded-xl border border-white/10"
                    >
                      <SearchCheck
                        size={18}
                        className="text-indigo-400 shrink-0"
                      />
                      <span className="text-[13px] font-medium text-slate-200">
                        {ind}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= QUALITY COMPLIANCE (BENTO GRID) ================= */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-slate-900 tracking-tight mb-16">
            Security & Validation Standards
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            {[
              {
                icon: ShieldCheck,
                t: "Multi-tier Linguistic QA",
                d: "Independent cross-verification of transcription accuracy indices.",
              },
              {
                icon: Activity,
                t: "99.9% Consistently",
                d: "Rigorous consensus review protocols for high-fidelity data outputs.",
              },
              {
                icon: Lock,
                t: "SOC2 Secure Ingestion",
                d: "Encrypted data handling tunnels for sensitive enterprise audio files.",
              },
            ].map((q, i) => (
              <div
                key={i}
                className="p-8 rounded-2xl bg-slate-50 border border-slate-100 text-left hover:bg-white hover:shadow-md transition-all"
              >
                <q.icon className="text-indigo-600 mb-4" size={24} />
                <h4 className="font-bold text-slate-900 mb-2">{q.t}</h4>
                <p className="text-xs text-slate-500 leading-relaxed font-light">
                  {q.d}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= FINAL CTA ================= */}
      <section className="py-24 bg-[#0f172a] relative overflow-hidden border-t border-white/5 text-center">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-indigo-500/10 rounded-full blur-[120px]" />

        <div className="relative z-10 max-w-4xl mx-auto px-6">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6 tracking-tight">
            Structure Your Acoustic Data.
          </h2>
          <p className="text-slate-400 mb-10 text-lg font-light leading-relaxed max-w-2xl mx-auto">
            Build accurate and scalable speech datasets with certified
            linguists. Let's discuss your transcription requirements today.
          </p>
          <div className="flex justify-center gap-4">
            <Link
              to="/contact"
              className="bg-white text-slate-900 px-10 py-3.5 rounded-xl font-bold text-sm hover:bg-indigo-50 transition-all shadow-xl shadow-black/20"
            >
              Initiate Technical Consultation
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default PhoneticTranscription;